import type { FC } from 'react';
import { Grid2, Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import IconWithText from 'components/IconWithText';
import ScaleImage from '/public/images/platform/scale.svg?icon';
import PeopleImage from '/public/images/platform/people.svg?icon';
import ToolImage from '/public/images/platform/tool.svg?icon';

const dataList = [
  {
    icon: ScaleImage,
    tTitle: 'scaleTitle',
    dataAos: 'fade-right',
    tDescription: 'scaleDescription',
  },
  {
    icon: PeopleImage,
    tTitle: 'peopleTitle',
    dataAos: 'fade-up',
    tDescription: 'peopleDescription',
  },
  {
    icon: ToolImage,
    tTitle: 'integratedTitle',
    dataAos: 'fade-left',
    tDescription: 'integratedDescription',
  },
];

const Platform: FC = () => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid2
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretched', sm: 'center' }}
      justifyContent={'center'}
      spacing={4}
      container
      data-aos={'fade-down'}
    >
      <Grid2
        size={{
          xs: 12,
          sm: 12,
        }}
      >
        <Box
          sx={{
            fontSize: {
              xs: '32px',
              md: '40px',
            },
            fontWeight: 700,
          }}
          textAlign={'center'}
        >
          {t('platformTitle')}
        </Box>
        <Typography
          sx={{ fontWeight: 400 }}
          variant={'h6'}
          align="left"
          color={'text.secondary'}
          py={2}
        >
          {t('platformDescription')}
        </Typography>
      </Grid2>
      <Grid2 size={12} container spacing={4} sx={{ flexGrow: 1 }}>
        {dataList.map((item, i) => (
          <Grid2
            size={{
              xs: 12,
              md: 4,
            }}
            key={i}
            data-aos={item.dataAos}
          >
            <IconWithText
              title={t(item.tTitle)}
              icon={item.icon}
              iconSx={{
                fontSize: '64px',
              }}
              typographySx={{
                fontWeight: 700,
                fontSize: {
                  xs: '18px',
                  md: '24px',
                },
              }}
              boxSx={{
                background: '#fff',
                width: '100%',
                p: 0,
                borderRadius: 0,
              }}
              description={t(item.tDescription)}
              descriptionSx={{
                color: '#333',
                fontWeight: 400,
                fontSize: {
                  xs: '16px',
                  md: '20px',
                },
              }}
            />
          </Grid2>
        ))}
      </Grid2>
    </Grid2>
  );
};

export default Platform;
